import axios, { AxiosResponse } from 'axios';
import { LightCredentials } from '@/store';

const LIGHT_ENDPOINT = process.env.LIGHT_ENDPOINT || 'http://192.168.56.1';

async function requestDeviceInfo(): Promise<AxiosResponse<string>> {
  const source = axios.CancelToken.source();
  setTimeout(() => {
    source.cancel();
  }, 1000);
  return axios.get<string>(`${LIGHT_ENDPOINT}/device`, {
    cancelToken: source.token,
  });
}

async function pairDevice(
  params: LightCredentials,
): Promise<AxiosResponse<void>> {
  console.log(`Sending credentials ${JSON.stringify(params)}`);
  return axios.post<void>(`${LIGHT_ENDPOINT}/pairing`, params);
}

async function sendCredentials(credentialsForTheLight: any): Promise<number> {
  return new Promise<number>(resolve => {
    if (credentialsForTheLight != undefined) {
      const block = async () => {
        try {
          console.log(`Starting pairing`);
          const result = await pairDevice(credentialsForTheLight);
          if (result.status === 200) {
            window.clearInterval(token);
            resolve(0);
          }
          console.log(`Done, result is ${JSON.stringify(result)}`);
        } catch (e) { }
      };
      const token = window.setInterval(block, 2000);
    } else {
      throw new Error('Empty light credentials');
    }
  });
}

async function confirmLightCreation(
  lightIp: string | undefined,
): Promise<number> {
  return new Promise<number>((resolve, reject) => {
    const timeStart = new Date().getTime();
    if (lightIp != undefined) {
      const block = async () => {
        const now = new Date().getTime();
        if (now - timeStart > 600000) {
          window.clearInterval(token);
          reject(new Error('Timeout'));
        }
        const source = axios.CancelToken.source();
        setTimeout(() => {
          source.cancel();
        }, 1500);
        try {
          console.log(`Confirming light creation, using IP ${lightIp}`);
          const result = await axios.post<void>(`http://${lightIp}/complete`, {}, {
            cancelToken: source.token,
          });
          if (result.status === 200) {
            window.clearInterval(token);
            resolve(0);
          }
          console.log(`Done, result is ${JSON.stringify(result)}`);
        } catch (e) {
          console.log(
            `Error when confirming light creation ${JSON.stringify(e)}`,
          );
        }
      };
      const token = window.setInterval(block, 2000);
    } else {
      throw new Error('Empty light credentials');
    }
  });
}

export { requestDeviceInfo, pairDevice, confirmLightCreation, sendCredentials };



// WEBPACK FOOTER //
// ./src/helpers/lightManager.ts